import { Button, Grid, Link, Paper, useTheme, Typography } from "@mui/material";
import { AccountingBill, AccountingBillHeaderLine } from "./AccountingBill";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { SearchBox } from "@/common/StyledComponents";
import {
    openLinesPopup,
    searchBills,
    selectToAllocateBills,
    selectToAllocateLines,
} from "./actualSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectOrganizationPublicId } from "@/auth/authSlice";
import SubscriptionComponent from "@/common/SubscriptionComponent";
import AccountingBillUploadPopup from "./AccountingBillUploadPopup";
import ExitToAppRoundedIcon from "@mui/icons-material/ExitToAppRounded";

export default function AccountingBills({ bills, selectable }) {
    return (
        <>
            <AccountingBillHeaderLine selectable={selectable} />
            {bills.length > 0 ? (
                <>
                    {bills.map(
                        (bill, index) =>
                            bill.main_bill_id == null && (
                                <AccountingBill
                                    key={index}
                                    billId={bill.id}
                                    selectable={selectable}
                                />
                            ),
                    )}
                </>
            ) : (
                <>
                    <Paper
                        sx={{
                            textAlign: "center",
                            boxShadow: "none",
                            padding: 4,
                        }}
                    >
                        <span style={{ fontSize: 14, color: "gray" }}>
                            No bills here
                        </span>
                    </Paper>
                </>
            )}
        </>
    );
}

export const AccountingBillsHeader = ({ getProject }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const organizationPublicId = useSelector(selectOrganizationPublicId);
    const handleSearch = (event) => {
        const value = event.target.value;
        dispatch(searchBills(value));
    };
    const checkedBills = useSelector((state) => selectToAllocateBills(state));
    const hasCheckedBills = checkedBills.length > 0;
    return (
        <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            paddingBottom={2}
            position={"sticky"}
            top={-1}
            zIndex={1}
            padding={1}
            sx={{ background: theme.palette.background.default }}
        >
            <Grid item>
                <Typography variant="h2">Bills</Typography>
            </Grid>
            <Grid item>
                <Grid container spacing={2}>
                    <SubscriptionComponent feature={"actualize"}>
                        <Grid item>
                            <AccountingBillUploadPopup
                                getProject={getProject}
                            />
                        </Grid>
                    </SubscriptionComponent>
                    <SubscriptionComponent feature={"actualize"}>
                        <Grid item>
                            <Button
                                LinkComponent={"a"}
                                target="_blank"
                                href={`/ap/invoice?public_id=${organizationPublicId}`}
                                variant="contained"
                                startIcon={<ExitToAppRoundedIcon />}
                            >
                                Invoice Portal
                            </Button>
                        </Grid>
                    </SubscriptionComponent>
                    <Grid item>
                        <Button
                            disabled={!hasCheckedBills}
                            onClick={() => {
                                dispatch(openLinesPopup());
                            }}
                            variant="contained"
                            startIcon={<EditOutlinedIcon />}
                        >
                            Approve and allocate
                        </Button>
                    </Grid>
                    <Grid item>
                        <SearchBox handleSearch={handleSearch} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
